import {Component, Input, OnDestroy} from '@angular/core';

/**
 * Campo in sola lettura con pulsante "copia".
 * Mostra `value`; al clic sull'icona copia negli appunti `copyText` (se indicato) oppure `value`.
 */
@Component({
    selector: 'app-copy-field',
    templateUrl: './copy-field.component.html',
    styleUrls: ['./copy-field.component.css']
})
export class CopyFieldComponent implements OnDestroy {
    @Input() value: string | number | null | undefined = '';
    @Input() copyText: string | null | undefined = null;
    @Input() emptyText = '';
    @Input() multiline = false;

    copied = false;
    private resetTimer: any = null;

    get display(): string {
        if (this.value === null || this.value === undefined) {
            return '';
        }
        return String(this.value).trim();
    }

    get hasValue(): boolean {
        return this.display.length > 0;
    }

    copy(): void {
        const text = this.copyText !== null && this.copyText !== undefined
            ? this.copyText
            : this.display;
        if (!text) {
            return;
        }

        this.writeToClipboard(text).then(() => {
            this.copied = true;
            clearTimeout(this.resetTimer);
            this.resetTimer = setTimeout(() => this.copied = false, 1500);
        }).catch(() => {});
    }

    ngOnDestroy(): void {
        clearTimeout(this.resetTimer);
    }

    private writeToClipboard(text: string): Promise<void> {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        return new Promise<void>((resolve, reject) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy') ? resolve() : reject();
            } catch (e) {
                reject(e);
            } finally {
                document.body.removeChild(textarea);
            }
        });
    }
}
